// extracted by mini-css-extract-plugin
export default {"errorPage":"ErrorPage_errorPage__RPfUu","errorPageLogo":"ErrorPage_errorPageLogo__7xBO8"};